import { useState } from "react";

import Avatar from "@mui/material/Avatar";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";

import Editor from "../../../../../utils/common/Editor";

import SyncIcon from "@mui/icons-material/Sync";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import AttachFileIcon from "@mui/icons-material/AttachFile";
import InsertLinkIcon from "@mui/icons-material/InsertLink";

import ThumbUpOutlinedIcon from "@mui/icons-material/ThumbUpOutlined";
import ThumbDownOutlinedIcon from "@mui/icons-material/ThumbDownOutlined";

import ThankYouModal from "../ThankYouModal";
import EmailGenerate from "./EmailGenerate";

const customToolbar = {
  container: "#email-ai-custom-toolbar",
  handlers: {},
};

const EmailReply = ({ handleCloseReply, user }: any) => {
  const { profileUrl, firstName, lastName, email, emailTo, date } = user || {};

  const [openAI, setOpenAI] = useState<boolean>(false);
  const [openThankYouModal, setOpenThankYouModal] = useState<boolean>(false);

  const [editorData, setEditorData] = useState(
    "<p><span style='font-size: 14px;'>Hi</span></p>"
    //  "<p><span style='font-size: 14px;'>Hi Cheyenne,﻿</span></p><p>Check a few things to avoid issues with pairing:</p><p>1. Please check your Wi-Fi settings before pairing up and make sure that you are connected to a 2.4GHz Wi-Fi network.</p><p>2. Make sure that you've entered your correct Wi-Fi password.</p><p>3. While connecting/adding your camera, it's suggested to place the camera near your Wi-Fi router.Once you move your camera near the Wi-Fi router, there should be no obstructions or any objects that may block the signal from the router to your camera.</p><p>4. Ensure the Location or GPS on your phone is enabled, and Allow the permissions for your App.a. IOS: Settings &gt; Privacy &gt; Location Service &gt; Make sure that YI Home App is set to WHILE USINGb. Android: Settings &gt; Security &amp; Location &gt; Privacy &gt; Location should be ON5. Reset the camera until you hear the 'reset is successful' voice prompt.</p>"
  );

  const handleOnChange = (value: any) => {
    setEditorData(value);
  };

  const handleInsertReply = (value: any) => {
    setEditorData((prevState) => prevState + value);
  };

  const handleOpenThankYouModal = () => {
    setOpenThankYouModal(true);
  };

  const handleCloseThankYouModal = () => {
    setOpenThankYouModal(false);
  };

  return (
    <Grid container mt="22px">
      <Grid item md={0.5} xs={12}>
        {profileUrl && <Avatar src={profileUrl} />}
        {!profileUrl && (
          <Avatar
            sx={{
              fontSize: "15px",
              color: "#3D4043",
              letterSpacing: "-2px",
            }}
          >
            {firstName?.[0]} {lastName?.[0]}
          </Avatar>
        )}
      </Grid>
      <Grid
        item
        md={11.5}
        xs={12}
        sx={{
          boxShadow: " 0px 12px 24px 0px #3D404333",
          borderRadius: "8px",
        }}
      >
        <Grid
          container
          item
          xs={12}
          alignItems="center"
          gap="11px"
          sx={{
            padding: "15px",
            borderBottom: "1px solid rgba(0, 0, 0, 0.2)",
          }}
        >
          <Box>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="12"
              height="12"
              viewBox="0 0 12 12"
              fill="none"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.28009 0.969592C4.4207 1.11024 4.49968 1.30097 4.49968 1.49984C4.49968 1.69871 4.4207 1.88944 4.28009 2.03009L2.56034 3.74984H6.74985C8.14223 3.74984 9.4776 4.30297 10.4621 5.28753C11.4467 6.27207 11.9999 7.60744 11.9999 8.99982V10.4998C11.9999 10.6987 11.9208 10.8895 11.7802 11.0301C11.6396 11.1708 11.4488 11.2498 11.2499 11.2498C11.051 11.2498 10.8602 11.1708 10.7195 11.0301C10.5788 10.8895 10.4999 10.6987 10.4999 10.4998V8.99982C10.4999 8.00524 10.1048 7.05147 9.40148 6.3482C8.6982 5.64493 7.74443 5.24984 6.74985 5.24984H2.56034L4.28009 6.96957C4.35173 7.03879 4.40886 7.12152 4.44817 7.21302C4.48748 7.30452 4.50816 7.40299 4.50903 7.50252C4.50989 7.60212 4.49092 7.70089 4.45321 7.79307C4.4155 7.88524 4.3598 7.96895 4.28939 8.03937C4.21897 8.1098 4.13523 8.16552 4.04306 8.20324C3.95088 8.24089 3.85212 8.25987 3.75254 8.25904C3.65296 8.25814 3.55454 8.23744 3.46304 8.19814C3.37154 8.15884 3.28877 8.10169 3.21959 8.03007L0.219592 5.03009C0.07899 4.88944 0 4.69871 0 4.49984C0 4.30097 0.07899 4.11024 0.219592 3.96959L3.21959 0.969592C3.36023 0.82899 3.55097 0.75 3.74984 0.75C3.94871 0.75 4.13945 0.82899 4.28009 0.969592Z"
                fill="#757775"
              />
            </svg>
          </Box>

          <Box>
            <Typography
              sx={{
                fontSize: "14px",
                color: "#3D4043",
              }}
            >
              {emailTo}
            </Typography>
          </Box>
        </Grid>
        <Grid
          item
          container
          sx={{
            padding: "20px",
          }}
        >
          <Grid
            container
            item
            xs={12}
            sx={{
              // padding: "20px",
              // background: openAI
              //   ? "rgba(219, 220, 224, 0.37)"
              //   : "rgba(32, 32, 32, 0.02)",
              borderRadius: "12px",
              "& .react-quil-container": {
                "& .ql-container": {
                  border: "0",
                  borderRadius: "8px",
                },
                "& .ql-editor": {
                  padding: 0,
                },
                "&.hoverOnQuill": {
                  "&:hover": {
                    outline: "0!important",
                  },
                },
              },
            }}
            gap="25px"
            justifyContent="space-between"
          >
            <Box display="flex" flexBasis="62%">
              <Editor
                enableCustomToolBar
                customToolbar={customToolbar}
                editorData={editorData}
                updateData={handleOnChange}
              />
            </Box>
            <EmailGenerate handleInsertReply={handleInsertReply} />
          </Grid>

          <Grid container item xs={12} mt="10px">
            <Box
              id="email-ai-custom-toolbar"
              sx={{
                width: "62%",
                boxShadow: " 0px 12px 24px 0px #3D404333",
                borderRadius: "4px",
              }}
            >
              <select
                className="ql-header"
                defaultValue={""}
                onChange={(e) => e.persist()}
              >
                <option value="1" />
                <option value="2" />
                <option selected />
              </select>
              <button className="ql-bold" />
              <button className="ql-italic" />
              <select className="ql-color">
                <option value="red" />
                <option value="green" />
                <option value="blue" />
                <option value="orange" />
                <option value="violet" />
                <option value="#d0d1d2" />
                <option selected />
              </select>
            </Box>
          </Grid>

          <Grid container item xs={12} mt="10px" justifyContent="space-between">
            <Box display="flex" gap="10px">
              <Button
                sx={{
                  borderRadius: "8px",
                }}
                variant="contained"
                startIcon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="14"
                    viewBox="0 0 16 14"
                    fill="none"
                  >
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M7.67325 4.00801C3.57471 5.9369 0.191713 7.53777 0.155454 7.56552C0.119194 7.59328 0.0677387 7.66166 0.0410747 7.7175C0.00135883 7.80074 -0.00541816 7.83715 0.00344407 7.91957C0.0157624 8.03404 0.086776 8.16433 0.166575 8.21882C0.271705 8.29063 4.15641 10.054 4.17663 10.0391C4.18783 10.0308 5.81303 8.75028 7.78821 7.19337C9.76338 5.63648 11.5011 4.26677 11.6497 4.1496C11.9113 3.94348 11.8902 3.96556 11.0029 4.82851C10.4985 5.3191 8.97096 6.79539 7.60836 8.10918L5.13089 10.4979L5.18524 10.5245C5.21513 10.5392 6.32691 11.0481 7.65585 11.6554C10.0049 12.7288 10.0753 12.7595 10.1852 12.7591C10.3277 12.7586 10.4365 12.7124 10.52 12.617C10.5704 12.5595 11.0899 11.3199 12.9951 6.71149C14.3213 3.5035 15.4163 0.844276 15.4285 0.802124C15.4719 0.651591 15.3529 0.497946 15.1947 0.500021C15.1424 0.500725 13.271 1.37353 7.67325 4.00801ZM5.1334 12.3393C5.1334 13.2406 5.13579 13.3108 5.16868 13.3696C5.18808 13.4043 5.23357 13.4479 5.26975 13.4665C5.39548 13.5312 5.43281 13.5181 5.79461 13.2828C6.92917 12.5446 7.23352 12.3414 7.22193 12.3299C7.21 12.3179 5.5312 11.5458 5.25407 11.4248L5.1334 11.3721V12.3393Z"
                      fill="white"
                    />
                  </svg>
                }
                onClick={handleOpenThankYouModal}
              >
                SEND
              </Button>

              <IconButton>
                <AttachFileIcon />
              </IconButton>

              <IconButton>
                <InsertLinkIcon />
              </IconButton>
            </Box>

            <Box>
              <IconButton onClick={handleCloseReply}>
                <DeleteOutlineIcon />
              </IconButton>
            </Box>
          </Grid>
        </Grid>
      </Grid>

      {openThankYouModal && (
        <ThankYouModal
          open={openThankYouModal}
          onClose={handleCloseThankYouModal}
        />
      )}
    </Grid>
  );
};

export default EmailReply;
